import React from 'react'
import { ProgressBar } from '../../components/ProgressBar'
import { useFormContext } from './FormContext'

export const FormProgressBar = () => {
  const { percentComplete } = useFormContext()
  return percentComplete > 0 ? <ProgressBar percentComplete={percentComplete} /> : null
}
